<template>
  <el-tooltip placement="top" effect="dark" popper-class="leo-knowledge-tip-popper">
    <div slot="content" class="leo-tip-rich">{{ tip }}</div>
    <i class="el-icon-question leo-inline-option-tip-icon" />
  </el-tooltip>
</template>

<script>
export default {
  name: 'LeoInlineOptionTip',
  props: {
    tip: { type: String, required: true }
  }
}
</script>

<style scoped>
.leo-inline-option-tip-icon {
  margin-left: 4px;
  color: #909399;
  cursor: help;
  font-size: 14px;
  vertical-align: middle;
}
.leo-inline-option-tip-icon:hover {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/LeoKnowledge/LeoInlineOptionTip.vue